import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@/app/core/enums/PermissionEnum";

export const routePrivateOrders: Array<RouteRecordRaw> = [
  {
    path: "orders",
    alias: ["orders", "dispatches"],
    name: "Orders",
    meta: {
      requireAuth: true,
    },
    redirect: (to) => {
      return { name: "OrdersList" };
    },
    component: () => import("@/app/private/pages/orders/Orders.vue"),
    children: [
      {
        path: "",
        name: "OrdersList",
        component: () =>
          import(
            "@/app/private/pages/orders/OrdersList.vue"
          ),
      },
      {
        path: "accept/:uuid",
        name: "AcceptOrder",
        meta: {
          requireAuth: true,
          permissions: [PermissionEnum.OrdersAccept],
        },
        component: () =>
          import("@/app/private/pages/orders/AcceptOrder.vue"),
      },
      {
        path: ":uuid/accept-load",
        name: "LoadAcceptance",
        meta: {
          requireAuth: true,
          permissions: [PermissionEnum.OrdersAccept],
        },
        component: () =>
          import("@/app/private/pages/orders/OrdersList.vue"),
      },
    ],
  },
];